import React from 'react';
import { TextField, Box } from '@mui/material';

const ModernTextField = ({ 
  label,
  sx = {},
  ...props 
}) => {
  return (
    <TextField
      label={label}
      fullWidth
      variant="outlined"
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 2,
          backgroundColor: 'background.paper',
          '& fieldset': {
            borderColor: 'grey.300',
            borderWidth: '1px',
          },
          '&:hover fieldset': {
            borderColor: 'primary.main',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'primary.main',
            borderWidth: '2px',
          },
        },
        '& .MuiInputLabel-root': {
          color: 'text.secondary',
          '&.Mui-focused': {
            color: 'primary.main',
          },
        },
        '& .MuiFormHelperText-root': {
          fontSize: '0.75rem',
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default ModernTextField;
